export default async function refetchMetadata({ graphql, props, state }) {
  await graphql.mutate(`{
        refetchMetadata(id: "${props.id}")
      }`)
}



// WEBPACK FOOTER //
// ./src/modules/Media/actions/refetchMetadata.js